module.exports = "/_next/static/files/bc2799e974896b2269fa5b51673aeced.jpg";